import _ from "lodash";
import {CheckCircleFilled} from "@ant-design/icons";
import {Popover} from "antd";
import FractionProgress from "@/components/FractionProgress.js";
import React from "react";
import {pp} from "@/utils.js";

let PlayersCheckinStatus = ({players, width, t}) => {
    let title;
    if (players.length === 1)
        title = players[0].name;
    else
    if (players.length === 2) {
        title = `${players[0].fname[0]}${players[0].lname[0]} & ${players[1].fname[0]}${players[1].lname[0]}`;
    }
    else
        title = t?.name;

    title = _.truncate(title || "", { length: 14 });

    let phones = gon.phones_map || {};

    let content = <div>
        {_.sortBy(_.compact(players), 'name').map(pl => <div key={pl.id} className="flex flex-row">
            <div style={{width: "20px", marginTop: "-3px"}}>{pl.checked_in && <CheckCircleFilled style={{color: "#84cc16"}}/>}</div>
            <div style={{width: "175px"}}>{pl.name}</div>
            <div style={{width: "150px"}}>{phones[pl.id] || pl.phone_view}</div>
        </div>)}
    </div>

    return <Popover content={content}>
        <div style={{width}} onClick={() => 1}>
            <FractionProgress checkmarkOnly={players.length > 2} noNums={players.length <= 2} title={title} steps max={players.length} num={_.filter(players, 'checked_in')} onClick={() => 1}/>
        </div>
    </Popover>

}

export default PlayersCheckinStatus;